import { isEmpty } from "./IsEmpty";
/**
 * @deprecated The name is incorrect since it handles any string,
 * not just pascal case. This function just calls {@link toSnakeCase}
 *
 */
export const pascalToSnakeCase = (input) => {
    return toSnakeCase(input);
};
/**
 * Converts a string to snake_case.
 *
 * @param input - The string to convert. Can be undefined.
 * @returns The converted snake_case string. Returns an empty string if input is empty or undefined.
 *
 * @example
 * pascalToSnakeCase("HelloWorld") // returns "hello_world"
 * pascalToSnakeCase("ABC") // returns "abc"
 * pascalToSnakeCase("ABCase") // returns "ab_case"
 * pascalToSnakeCase() // returns ""
 */
export const toSnakeCase = (input) => {
    if (isEmpty(input)) {
        return '';
    }
    const str = input;
    return str
        .replace(/(?<![A-Z])([A-Z])/g, '_$1') // put _ when going from lower to upper case. aa_BBaa
        .replace(/([A-Z])(?=[a-z0-9])/g, '_$1') // put _ when going from upper to lower case. aaBB_aa
        .replace(/[^a-zA-Z0-9]+(.)/g, '_$1') // replace any non-alphanumeric with underscore
        .replace(/^_+|_+$/g, '') // remove leading/trailing underscores
        .toLowerCase();
};
//# sourceMappingURL=StringUtils.js.map